import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { UserForm } from "@auth/components/UserForm";
import { messages as authMessages } from "@auth/messages";
import { messages as uiMessages } from "@ui/messages";
import { Page, CardBody, Card, PageTitle } from "@ui/Page";
import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { compose } from "@util/compose";

type Props = RouteComponentProps<any>;

const UsersCreate = ({ history }: Props) => {
    const intl = useIntl();
    const title = intl.formatMessage(uiMessages.createEntity, {
        entity: intl.formatMessage(authMessages.userEntityIndefiniteArticle),
    });

    const onSuccess = () => {
        history.push("/users");
    };

    const breadcrumbItems = [
        {
            text: <FormattedMessage {...authMessages.userEntityPlural} />,
            to: "/users",
        },
        {
            text: title,
        },
    ];

    return (
        <Page className="users-create-page" breadcrumbs={breadcrumbItems}>
            <PageTitle tag="h1" className="display-2">
                {title}
            </PageTitle>
            <Card>
                <CardBody>
                    <UserForm intl={intl} onSuccess={onSuccess} />
                </CardBody>
            </Card>
        </Page>
    );
};

// Inject intl and set title
const ConnectedUsersCreate = compose<Props, {}>(
    setTitleOnPage(
        messages.pageUsersTitle, messages.pageUsersCreateTitle,
    ),
    withRouter,
)(UsersCreate);

export {
    UsersCreate as UsersCreatePresenter,
    ConnectedUsersCreate as UsersCreate,
};
